<p>users-menu-permissions works!</p>
